import { render, staticRenderFns } from "./TeamTopCard.vue?vue&type=template&id=3a519842&scoped=true"
import script from "./TeamTopCard.vue?vue&type=script&lang=js"
export * from "./TeamTopCard.vue?vue&type=script&lang=js"
import style0 from "./TeamTopCard.vue?vue&type=style&index=0&id=3a519842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a519842",
  null
  
)

export default component.exports